import React from 'react';
import { I18n } from 'react-redux-i18n';
import { Button, Modal } from 'semantic-ui-react';

import { SwiftaidUnlinkReason } from './unlinkWarning';

const i18nPath =
  'template.organisation.content.finance.swiftaid.unlink-warning';

interface SwiftaidUnlinkConfirmProps {
  /** Why the save would disconnect Swiftaid. The modal is closed while this is null. */
  reason: SwiftaidUnlinkReason | null;
  onCancel: () => void;
  onConfirm: () => void;
}

/**
 * Asks before a save that would disconnect Swiftaid, because the API drops the link as
 * soon as the HMRC charity reference is changed or cleared. Cancelling leaves the form as
 * it is, so the user can put the reference back.
 */
export const SwiftaidUnlinkConfirm = ({
  reason,
  onCancel,
  onConfirm
}: SwiftaidUnlinkConfirmProps) => (
  <Modal
    className="wizard"
    size="small"
    dimmer="inverted"
    closeIcon
    open={reason !== null}
    onClose={onCancel}
    aria-labelledby="swiftaidUnlinkHeader"
    aria-describedby="swiftaidUnlinkBody"
  >
    <Modal.Header>
      <h3 id="swiftaidUnlinkHeader">{I18n.t(`${i18nPath}.header`)}</h3>
    </Modal.Header>
    <Modal.Content>
      <p id="swiftaidUnlinkBody">
        {reason && I18n.t(`${i18nPath}.body.${reason}`)}
      </p>
      <div className="button-wrapper align-right" style={{ marginTop: 16 }}>
        <Button id="btnSwiftaidUnlinkCancel" onClick={onCancel}>
          {I18n.t(`${i18nPath}.cancel`)}
        </Button>
        <Button id="btnSwiftaidUnlinkConfirm" negative onClick={onConfirm}>
          {I18n.t(`${i18nPath}.confirm`)}
        </Button>
      </div>
    </Modal.Content>
  </Modal>
);

export default SwiftaidUnlinkConfirm;
